module.exports = __webpack_public_path__ + "img/맥형띠배너_desktop.d7eb2a94.png";